import { type DatabaseChangeType } from '@databases/types/redux';

import { parentPageTypeMapping } from '../../../collab/convert-to-collab';
import { type YJSChangeHandler } from '../../types';

export const setPageLocation: YJSChangeHandler<DatabaseChangeType.SET_PAGE_LOCATION> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.parentPageType = parentPageTypeMapping[change.newParentPageType];
  });
};
